import { defineComponent as _defineComponent } from 'vue'
import {
  ref,
  defineAsyncComponent,
  markRaw,
  computed,
  inject,
  watch,
} from 'vue'
import { useCookies } from '@vueuse/integrations/useCookies'
import { storeToRefs } from 'pinia'
import { useRoute, useRouter } from 'vue-router'
import { useTitle } from '@vueuse/core'
import { useI18n } from 'vue-i18n'
import { prefixLanguage } from '@utils/urls'
import { useAuthStore } from '@m/auth/store'
// import { useFacilityStore } from '@m/cabinet/modules/Facility/store'
import { useModalOpener } from '@/composables/useModalOpener'

import useLogout from '@/composables/useLogout'
import { useConfirmDialog } from '@/composables/useConfirm'

import { toHash } from '@m/cabinet/utils'

import {
  STAFF_PROFILE_VIEW_NAME,
  STAFF_FACILITIES_VIEW_NAME,
  FACILITIES_MODERATION_VIEW_NAME,
  FACILITIES_STAFF_VIEW_NAME,
  STAFF_SERVICES_VIEW_NAME,
  STAFF_SEVICES_MODERATION_LIST_VIEW_NAME,
  STAFF_LOCAL_SERVICES_LIST_VIEW_NAME,
  STAFF_SETTING_VIEW_NAME,
  STAFF_SETTING_USERS_LIST_VIEW_NAME,
  STAFF_ANALYTICS_VIEW_NAME,
  STAFF_ANALYTICS_USERS_LIST_VIEW_NAME,
  STAFF_ANALYTICS_FACILITIES_LIST_VIEW_NAME,
  STAFF_ANALYTICS_APPOINTMENTS_LIST_VIEW_NAME,
  STAFF_ANALYTICS_COMMISSION_LIST_VIEW_NAME,
  STAFF_ANALYTICS_INVOICES_LIST_VIEW_NAME,
  STAFF_DOCTORS_VIEW_NAME,
  STAFF_DOCTORS_LIST_VIEW_NAME,
} from '@m/cabinet/routes'

import {
  GET_PROFILE_TYPES,
  NOTIFICATIONS_FLAGS,
} from '@m/cabinet/modules/Profile/const'

// import { MEDIA_TAB_KEY, SCHEDULE_TAB_KEY } from '@/modules/cabinet/modules/Branch/const'
import { useUserStore } from '@/modules/user/store'
import { useMedicalChainStore } from '@m/cabinet/store'
import {
  CLIENT_ROLE_KEY,
  COORDINATOR_ROLE_KEY,
  DOCTOR_ROLE_KEY,
  SELECTED_USER_ROLE_COOKIE_NAME,
} from '@/const'
import { IS_COORDINATOR, IS_DOCTOR } from '@/modules/user/accessTokens'
import { isPermittedSimple } from '@/modules/user/permissions'
// import { useBranchesStore } from '@/modules/cabinet/modules/Branch/store';


export default /*@__PURE__*/_defineComponent({
  __name: 'StaffLayout',
  setup(__props, { expose: __expose }) {
  __expose();

const indexPageUrl = prefixLanguage('/')

const sizeChecker = (size: number) => size >= 1200

const route = useRoute()
const router = useRouter()

const authStore = useAuthStore()
const userStore = useUserStore()

const { notificationCounts } = storeToRefs(userStore)
const unreadNotificationCounter = computed(() => {
  return (
    notificationCounts.value?.flags.find(
      (el) => el.pk === NOTIFICATIONS_FLAGS.UNREAD
    )?.count || 0
  )
})
const { t } = useI18n()

const preparedMenu = computed(() => {
  const menu = [
    {
      icon: 'i-user',
      label: t('Profile'),
      to: { name: STAFF_PROFILE_VIEW_NAME },
    },
  ]

  const analyticsMenu = {
    icon: 'i-analytics',
    label: t('Analytics'),
    to: {
      name: STAFF_ANALYTICS_VIEW_NAME,
    },
    drop: true,
    isDropped: false,
    children: [
      {
        label: t('Users'),
        to: {
          name: STAFF_ANALYTICS_USERS_LIST_VIEW_NAME,
        },
      },
      {
        label: t('Medical facilities'),
        to: {
          name: STAFF_ANALYTICS_FACILITIES_LIST_VIEW_NAME,
        },
      },
      {
        label: t('Appointments'),
        to: {
          name: STAFF_ANALYTICS_APPOINTMENTS_LIST_VIEW_NAME,
        },
      },
      {
        label: t('Commission'),
        to: {
          name: STAFF_ANALYTICS_COMMISSION_LIST_VIEW_NAME,
        },
      },
      {
        label: t('Invoices issued'),
        to: {
          name: STAFF_ANALYTICS_INVOICES_LIST_VIEW_NAME,
        },
      },
    ],
  }
  menu.push(analyticsMenu)

  const facilitiesMenu = {
    icon: 'i-facility',
    label: t('Medical facility'),
    to: {
      name: STAFF_FACILITIES_VIEW_NAME,
    },
    drop: true,
    isDropped: false,
    children: [
      {
        label: t('Moderation requests'),
        to: {
          name: FACILITIES_MODERATION_VIEW_NAME,
        },
      },
      {
        label: t('Medical facility'),
        to: {
          name: FACILITIES_STAFF_VIEW_NAME,
        },
      },
    ],
  }
  menu.push(facilitiesMenu)
  const doctorsMenu = {
    icon: 'i-setting',
    label: t('Doctors'),
    to: {
      name: STAFF_DOCTORS_VIEW_NAME,
    },
    drop: true,
    isDropped: false,
    children: [
      {
        label: t('List'),
        to: {
          name: STAFF_DOCTORS_LIST_VIEW_NAME,
        },
      },
    ],
  }
  menu.push(doctorsMenu)

  const servicesMenu = {
    icon: 'i-services',
    label: t('Services'),
    to: {
      name: STAFF_SERVICES_VIEW_NAME,
    },
    drop: true,
    isDropped: false,
    children: [
      {
        label: t('Services requests'),
        to: {
          name: STAFF_SEVICES_MODERATION_LIST_VIEW_NAME,
        },
      },
      {
        label: t('Berrdo services'),
        to: {
          name: STAFF_LOCAL_SERVICES_LIST_VIEW_NAME,
        },
      },
    ],
  }
  menu.push(servicesMenu)

  const settingMenu = {
    icon: 'i-setting',
    label: t('Setting'),
    to: {
      name: STAFF_SETTING_VIEW_NAME,
    },
    drop: true,
    isDropped: false,
    children: [
      {
        label: t('Users'),
        to: {
          name: STAFF_SETTING_USERS_LIST_VIEW_NAME,
        },
      },
    ],
  }
  menu.push(settingMenu)
  // const documentFlowMenu = {
  //   icon: 'i-sticky-note',
  //   label: t('Document flow'),
  //   to: {
  //     name: DOCUMENTS_FLOW_VIEW_NAME,
  //     params: {
  //       chainId: medicalChainId.value,
  //     },
  //   },
  //   drop: false,
  //   isDropped: false,
  // }
  // if (medicalChainId.value) {
  //   menu.push(facilitiesMenu, documentFlowMenu)
  // }
  // const MEDICAL_APPOINTMENT_MENU = {
  //   icon: 'i-task',
  //   label: t('Appointments'),
  //   to: {
  //     name: MEDICAL_APPOINTMENT_LIST_VIEW_NAME,
  //     params: {
  //       chainId: medicalChainId.value,
  //     },
  //   },
  // }
  // if (medicalChainId.value && currentUserType.value === COORDINATOR_ROLE_KEY) {
  //   menu.push(MEDICAL_APPOINTMENT_MENU)
  // }

  // const EXISTING_DOCTOR = {
  //   icon: 'i-shield',
  //   label: t('Doctor data'),
  //   to: {
  //     name: doctorId.value ? DOCTOR_VIEW_NAME : DOCTOR_NOT_ADDED_VIEW_NAME,
  //     params: doctorId.value ? { id: doctorId.value } : {},
  //   },
  // }

  // const DOCTOR_APPOINTMENT_MENU = {
  //   icon: 'i-task',
  //   label: t('Appointments'),
  //   to: {
  //     name: DOCTOR_APPOINTMENT_LIST_VIEW_NAME,
  //     params: {
  //       doctorId: doctorId.value,
  //     },
  //   },
  // }
  // if (currentUserType.value === DOCTOR_ROLE_KEY) {
  //   menu.push(EXISTING_DOCTOR)
  //   if (doctorId.value) {
  //     menu.push(DOCTOR_APPOINTMENT_MENU)
  //   }
  // }

  // const APPOINTMENT_MENU = {
  //   icon: 'i-task',
  //   label: t('Appointments'),
  //   to: { name: APPOINTMENT_LIST_VIEW_NAME },
  // }
  // if (currentUserType.value === CLIENT_ROLE_KEY) {
  //   menu.push(APPOINTMENT_MENU)
  // }

  // // const REVIEWS_MENU = [{
  // //   icon: 'i-message-square',
  // //   label: t('Reviews'),
  // //   to: { name: REVIEWS_LIST_VIEW_NAME },
  // // }, {
  // //   icon: 'i-message-square',
  // //   label: t('Reviews'),
  // //   to: { name: APPOINTMENT_REVIEWS_LIST_VIEW_NAME },
  // // }]

  // // menu.push(...REVIEWS_MENU)

  // // const FACILITY_DOCUMENTS_FLOW_MENU = {
  // //   icon: 'i-document-text',
  // //   label: t('Document flow'),
  // //   to: { name: FACILITY_DOCUMENTS_FLOW_VIEWS_NAME },
  // // }
  // // menu.push(FACILITY_DOCUMENTS_FLOW_MENU)

  // // const FAVORITES_MENU = {

  // //   icon: 'i-heart',
  // //   label: t('Favorites'),
  // //   to: { name: FAVORITES_LIST_VIEW_NAME },
  // // }
  // // menu.push(FAVORITES_MENU)

  // const NOTIFICATIONS_MENU = {
  //   icon: 'i-message-text',
  //   label: t('Notifications'),
  //   to: { name: NOTIFICATIONS_VIEW_NAME },
  //   counter: unreadNotificationCounter.value,
  // }
  // menu.push(NOTIFICATIONS_MENU)

  // const SETTINGS_MENU = {
  //   icon: 'i-settings',
  //   label: t('Settings'),
  //   to: { name: SETTINGS_BASE },
  //   drop: true,
  //   isDropped: false,
  //   children: [
  //     {
  //       label: t('Security'),
  //       to: { name: SECURITY_VIEW_NAME },
  //     },
  //     {
  //       label: t('Setting up notifications'),
  //       to: { name: NOTIFICATIONS_SETTINGS_VIEW_NAME },
  //     },
  //   ],
  // }
  // menu.push(SETTINGS_MENU)
  return menu
})

const navigation = computed(() => {
  return {
    sections: [
      {
        menu: preparedMenu.value,
      },
    ],
  }
})

const logout = async () => {
  const question = t('Are you sure you want to log out?')
  try {
    await useConfirmDialog({
      question,
    })
    await logoutAndRedirect()
  } catch (e) {
    console.warn(e)
  }
}
const logoutAndRedirect = async () => {
  try {
    await useLogout()
    window.location.href = window.login_url
  } catch (e) {
    console.warn(e)
  }
}

function openCreateFacilityModal() {
  let isGoToCreate = false
  function redirectToChainForm(val) {
    console.log('redirectToChainForm', val)
    isGoToCreate = val
    if (val) {
      router.push({
        name: CHAIN_CREATE_VIEW_NAME,
      })
    } else {
      router.push({
        name: FACILITY_SINGLE_CREATE_VIEW_NAME,
      })
    }
  }
  const { open } = useModalOpener(
    {
      component: defineAsyncComponent(
        () =>
          import(
            '@m/cabinet/modules/Chain/components/ConfirmCreateFacility.vue'
          )
      ),
      classes: ['modal--size_3sm'],
    },
    {},
    redirectToChainForm
  )
  open()
}

const comparisonsMenuItemRef = ref(null)
const facilityCreateMenuItemRef = ref(null)
const logoutMenuItemRef = ref(null)

function openCondensedMenuItem(element) {
  element.classList.add('is-opened')
}
function closeCondensedMenuItem(element) {
  element.classList.remove('is-opened')
}

const currentTitle = inject('currentTitle')

const title = computed(() => {
  const lastTitle = currentTitle.value?.title || currentTitle.value
  return (lastTitle ? lastTitle + ' | ' : ' ') + t('Berrdo')
})

useTitle(title)

const siteTitle = window.site_title
const showSiteTitle = window.show_site_title
const currentLanguageTitle = window.current_language
const partner_program_url = window.partner_program_url
const logoCabinet = window.logo_cabinet || null

const __returned__ = { indexPageUrl, sizeChecker, route, router, authStore, userStore, notificationCounts, unreadNotificationCounter, t, preparedMenu, navigation, logout, logoutAndRedirect, openCreateFacilityModal, comparisonsMenuItemRef, facilityCreateMenuItemRef, logoutMenuItemRef, openCondensedMenuItem, closeCondensedMenuItem, currentTitle, title, siteTitle, showSiteTitle, currentLanguageTitle, partner_program_url, logoCabinet, ref, defineAsyncComponent, markRaw, computed, inject, watch, get useCookies() { return useCookies }, get storeToRefs() { return storeToRefs }, get useRoute() { return useRoute }, get useRouter() { return useRouter }, get useTitle() { return useTitle }, get useI18n() { return useI18n }, get prefixLanguage() { return prefixLanguage }, get useAuthStore() { return useAuthStore }, get useModalOpener() { return useModalOpener }, get useLogout() { return useLogout }, get useConfirmDialog() { return useConfirmDialog }, get toHash() { return toHash }, get STAFF_PROFILE_VIEW_NAME() { return STAFF_PROFILE_VIEW_NAME }, get STAFF_FACILITIES_VIEW_NAME() { return STAFF_FACILITIES_VIEW_NAME }, get FACILITIES_MODERATION_VIEW_NAME() { return FACILITIES_MODERATION_VIEW_NAME }, get FACILITIES_STAFF_VIEW_NAME() { return FACILITIES_STAFF_VIEW_NAME }, get STAFF_SERVICES_VIEW_NAME() { return STAFF_SERVICES_VIEW_NAME }, get STAFF_SEVICES_MODERATION_LIST_VIEW_NAME() { return STAFF_SEVICES_MODERATION_LIST_VIEW_NAME }, get STAFF_LOCAL_SERVICES_LIST_VIEW_NAME() { return STAFF_LOCAL_SERVICES_LIST_VIEW_NAME }, get STAFF_SETTING_VIEW_NAME() { return STAFF_SETTING_VIEW_NAME }, get STAFF_SETTING_USERS_LIST_VIEW_NAME() { return STAFF_SETTING_USERS_LIST_VIEW_NAME }, get STAFF_ANALYTICS_VIEW_NAME() { return STAFF_ANALYTICS_VIEW_NAME }, get STAFF_ANALYTICS_USERS_LIST_VIEW_NAME() { return STAFF_ANALYTICS_USERS_LIST_VIEW_NAME }, get STAFF_ANALYTICS_FACILITIES_LIST_VIEW_NAME() { return STAFF_ANALYTICS_FACILITIES_LIST_VIEW_NAME }, get STAFF_ANALYTICS_APPOINTMENTS_LIST_VIEW_NAME() { return STAFF_ANALYTICS_APPOINTMENTS_LIST_VIEW_NAME }, get STAFF_ANALYTICS_COMMISSION_LIST_VIEW_NAME() { return STAFF_ANALYTICS_COMMISSION_LIST_VIEW_NAME }, get STAFF_ANALYTICS_INVOICES_LIST_VIEW_NAME() { return STAFF_ANALYTICS_INVOICES_LIST_VIEW_NAME }, get STAFF_DOCTORS_VIEW_NAME() { return STAFF_DOCTORS_VIEW_NAME }, get STAFF_DOCTORS_LIST_VIEW_NAME() { return STAFF_DOCTORS_LIST_VIEW_NAME }, get GET_PROFILE_TYPES() { return GET_PROFILE_TYPES }, get NOTIFICATIONS_FLAGS() { return NOTIFICATIONS_FLAGS }, get useUserStore() { return useUserStore }, get useMedicalChainStore() { return useMedicalChainStore }, get CLIENT_ROLE_KEY() { return CLIENT_ROLE_KEY }, get COORDINATOR_ROLE_KEY() { return COORDINATOR_ROLE_KEY }, get DOCTOR_ROLE_KEY() { return DOCTOR_ROLE_KEY }, get SELECTED_USER_ROLE_COOKIE_NAME() { return SELECTED_USER_ROLE_COOKIE_NAME }, get IS_COORDINATOR() { return IS_COORDINATOR }, get IS_DOCTOR() { return IS_DOCTOR }, get isPermittedSimple() { return isPermittedSimple } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})